<div class="flex-container-column-center height-100 bg-auth-accent">
	<div class="width-100 flex-container-row-nowrap justify-content-space-between box-sizing-border-box">
		<button class="button-reset btn--text padding-16px color-light-gray-on-accent" (click)="selectOrganisation()">
			<i class="fa fa-caret-left vertical-align-middle margin-right-4px"></i
			><span class="font-size-0-8rem">{{ "general.change_organisation" | translate }}</span>
		</button>
		<ic-change-language class="margin-top-4px margin-right-8px color-light-gray-on-accent" />
	</div>
	@if (isAppVersionOutdated$ | async) {
		<ic-outdated-app-version-header data-test="outdated-app-version-header" />
	}
	<form autocomplete="off" class="margin-top-auto" novalidate [formGroup]="form">
		<fieldset>
			<ic-form-field class="auth__username" data-test="user-name-form-field">
				<span icLabel>
					{{ "auth.username" | translate }}
				</span>

				<input
					autocapitalize="off"
					data-test="username-input"
					formControlName="username"
					icInput
					name="username"
					type="text"
				/>

				<span class="fa fa-user" icPrefix></span>

				@if (hasUsernameError) {
					<ic-error>
						{{ "auth.validators.username_required" | translate }}
					</ic-error>
				}
			</ic-form-field>

			<ic-form-field class="auth__password" data-test="pw-form-field">
				<span icLabel>
					{{ "auth.password" | translate }}
				</span>

				<input data-test="password-input" formControlName="password" icInput name="password" type="password" />

				<span class="fa fa-lock" icPrefix></span>

				@if (hasPasswordError) {
					<ic-error>
						{{ "auth.validators.password_required" | translate }}
					</ic-error>
				}
			</ic-form-field>

			<input
				data-test="submit-button"
				type="submit"
				value="{{ 'auth.signin' | translate }}"
				(click)="authenticate(form.value)"
			/>
		</fieldset>
	</form>
	<div
		class="width-100 text-align-center font-size-0-8rem color-light-gray-on-accent margin-top-auto margin-bottom-1rem"
	>
		{{ "settings.version" | translate }} {{ appVersion }}
	</div>
</div>
